﻿import { createFileRoute } from "@tanstack/react-router";
import { ontemISO, VendasDiaPage } from "@/paginas/pg_franquia/franquia-vendas-vendas-dia";

export const Route = createFileRoute("/_authenticated/franquia-vendas-vendas-dia")({
  validateSearch: (s: Record<string, unknown>) => ({
    data: typeof s["data"] === "string" && s["data"] ? (s["data"] as string) : ontemISO(),
  }),

  head: () => ({
    meta: [
      { title: "Vendas do dia — Milky Moo Palmares" },
      {
        name: "description",
        content: "Veja o total vendido de cada produto na data escolhida e exporte em PDF.",
      },
      { property: "og:title", content: "Vendas do dia — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Veja o total vendido de cada produto na data escolhida e exporte em PDF.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: VendasDiaPage,
});
